angular.module('impactx.list').controller('MultiCellCtrl', [
    'TranslationService',
    MultiCellCtrl]);

function MultiCellCtrl(TranslationService) {
    var self = this;

    self.trns = {};
    self.trns.and = TranslationService.get("and");
    self.trns.others = TranslationService.get("others");
}